export function GamePending() {
  return (
    <main id="main" className="px-8 py-16" aria-busy="true">
      <output>Loading game…</output>
    </main>
  );
}
